import {Component, OnInit} from '@angular/core';
import {ApiConfig, NodeBuilder} from '../../../../../../../shared/models';
import {FlowManagerService} from '../../../../../services/flow-manager.service';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import {HttpCallNode, KeyValue} from './httpCall';
import {newStepValue} from '../../../../../services/flowBuilder/utils/constants';
import {FlowBuilderService} from "../../../../../services/flowBuilder/flow-builder.service";
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatOption } from '@angular/material/select';
import { NgTemplateOutlet, NgClass, AsyncPipe, KeyValuePipe } from '@angular/common';
import { LoadingIconComponent } from '../../../../../../../shared/components/loading-icon/loading-icon.component';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

const NODE_TYPE = 'httpCall';

@Component({
    selector: 'app-http-call',
    templateUrl: './http-call.component.html',
    styleUrls: ['./http-call.component.scss'],
    imports: [ReactiveFormsModule, ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ClickatellFormValidationComponent, ActiveFormDirective, MatInput, MatAutocompleteTrigger, MatAutocomplete, MatOption, NgTemplateOutlet, LoadingIconComponent, CMSComponent, NextSelectorComponent, NgClass, AsyncPipe, KeyValuePipe]
})
export class HttpCallComponent extends NodeBuilder implements OnInit {

    apiDetails$: Observable<Map<string, ApiConfig>>;
    apiDetails: any;
    apiDetailNames: any = [];
    apiDetailNamesFilter: any = [];

    apiForm: UntypedFormGroup;
    readonly API_DETAILS_DISPLAY: string[] = ['elementValidation', 'method', 'poolName', 'requestType', 'responseType', 'url'];

    hasLoading = false;

    constructor(private flowManagerService: FlowManagerService,
                private flowBuilder: FlowBuilderService) {
        super(NODE_TYPE);
    }

    ngOnInit(): void {
    }

    set buildForm(stepData: any) {
        this.apiForm = HttpCallNode.toForm(stepData, this.canEdit);
        this.apiDetails$ = this.flowManagerService.getApis().pipe(
            tap((apiDetails) => {
                this.apiDetailNames = Object.keys(apiDetails);
                this.apiDetailNamesFilter = Object.keys(apiDetails);
                this.apiDetails = apiDetails;
                this.hasLoading = true;
                this.add_missing_body();
            })
        );

        const results: UntypedFormArray = this.apiForm.get('result') as UntypedFormArray;
        for (const key in results.controls) {
            const result: UntypedFormControl = results.controls[key].get('value') as UntypedFormControl;
            if (result.value === newStepValue) {
                result.setValue('step' + this.getNextStep());
            }
        }
    }

    get getStepData(): {} {
        const node = new HttpCallNode();
        node.addActionParams(this.apiForm.getRawValue());
        return node.nodeData;
    }

    get isNodeValid(): boolean {
        this.apiForm.markAllAsTouched();
        return this.apiForm.valid && this.hasLoading;
    }

    public apiInput(apiName: string): void {
        this.apiDetailNamesFilter = this.apiDetailNames?.filter(option => option.toLowerCase().includes(apiName));
    }

    public addKeyValue(controlName: string): void {
        const formData = this.apiForm.get(controlName) as UntypedFormArray;
        formData.push(HttpCallNode.addKeyValue(this.canEdit.canEditFlows));
    }

    public deleteKeyValue(controlName: string, index: number): void {
        const formData = this.apiForm.get(controlName) as UntypedFormArray;
        formData.removeAt(index);
    }

    public addResult() {
        const results = this.apiForm.get('result') as UntypedFormArray;
        const keyValue: KeyValue = {
            key: '',
            value: newStepValue
        };
        results.push(HttpCallNode.addKeyValue(this.canEdit.canEditFlows, keyValue));
    }

    public apiSelected(apiName: string): void {
        this.apiForm.markAllAsTouched();
        const apiDetail = this.apiDetails[apiName];
        if (apiDetail) {
            const editFlows = this.canEdit.canEditFlows;

            const headers: UntypedFormArray = this.apiForm.get('headers') as UntypedFormArray;
            const queryStrings: UntypedFormArray = this.apiForm.get('queryStrings') as UntypedFormArray;
            headers.clear();
            queryStrings.clear();
            this.apiForm.removeControl('body');

            if (apiDetail['method'] === 'POST' || apiDetail['method'] === 'PUT') {
                if (apiDetail['requestType'] === 'multipart/form-data') {
                    this.apiForm.addControl('body', HttpCallNode.buildHttpBody({}, editFlows));
                } else {
                    this.apiForm.addControl('body', HttpCallNode.buildHttpBody('', editFlows));
                }
            }
        }
    }

    private add_missing_body() {
        if (!this.apiForm.get('body')) {
            const apiName = this.apiForm.get('apiName').value;
            const apiDetail = this.apiDetails[apiName];
            if (apiDetail) {
                const editFlows = this.canEdit.canEditFlows;
                if (apiDetail['method'] === 'POST' || apiDetail['method'] === 'PUT') {
                    if (apiDetail['requestType'] === 'multipart/form-data') {
                        this.apiForm.addControl('body', HttpCallNode.buildHttpBody({}, editFlows));
                    } else {
                        this.apiForm.addControl('body', HttpCallNode.buildHttpBody('', editFlows));
                    }
                }
            }
        }
        this.flowBuilder.setNodeValid(this.nodeFlowDetails.stepId, this.isNodeValid);
    }
}
